import React from 'react';

import { DashMenuProps } from './interfaces';
import Main from './Main';

const DashMenu: React.FC<DashMenuProps> = ({
  options,
  dashMenuPath,
  useDashMenu,
  hiddenSupergroup,
  openSelectSuperGroup,
  isMobile,
}) => {
  return (
    <Main
      options={options}
      dashMenuPath={dashMenuPath}
      useDashMenu={useDashMenu}
      hiddenSupergroup={hiddenSupergroup}
      openSelectSuperGroup={openSelectSuperGroup}
      isMobile={isMobile}
    />
  );
};

export default DashMenu;
